/** What the browser stops on with Tab. */
export const TABBABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])';

/** What `useAutoFocusReturn` lands on: controls, menu items, links, and explicit tab stops. */
export const FOCUSABLE_SELECTOR =
  'input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [role="menuitem"]:not([tabindex^="-"]), button:not([disabled]):not([tabindex^="-"]), a[href], [tabindex]:not([tabindex^="-"])';

/**
 * Moves focus to the tab stop in `container` after the focused element, or before it,
 * wrapping at either end, so Tab never leaves it.
 */
export const moveTabWithin = (container: HTMLElement, backward: boolean): void => {
  const stops = Array.from(container.querySelectorAll<HTMLElement>(TABBABLE_SELECTOR));
  const focused = document.activeElement;
  const isAfterFocused = (stop: HTMLElement): boolean =>
    !focused || Boolean(focused.compareDocumentPosition(stop) & Node.DOCUMENT_POSITION_FOLLOWING);
  const target = backward
    ? (stops.filter((stop) => stop !== focused && !isAfterFocused(stop)).at(-1) ?? stops.at(-1))
    : (stops.find(isAfterFocused) ?? stops[0]);
  target?.focus();
};
